import apiInst from '../api.js';

class CompanyService {
  constructor() {
    console.log('Company service inst');
  }

  getClientsList() {
    return apiInst.get('/company/clients');
  }
}

export default new CompanyService();
